import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
const META_PIXEL_ID = '1579514146604651';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
function initMetaPixel() {
  try {
    if (typeof window === 'undefined') return;
    if (window.fbq) return;
    const n: any = window.fbq = function (...args: any[]) {
      if (n.callMethod) {
        n.callMethod.apply(n, args);
      } else {
        n.queue.push(args);
      }
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.onerror = () => {
      console.warn('Meta Pixel script failed to load, using image fallback');
      firePixelViaImage('PageView');
    };
    document.head.appendChild(script);
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
    // Also fire image pixel as fallback
    firePixelViaImage('PageView');
  } catch (e) {
    console.warn('Meta Pixel initialization failed:', e);
    firePixelViaImage('PageView');
  }
}
export function firePixelViaImage(eventName: string, params?: Record<string, any>) {
  try {
    const img = new Image(1, 1);
    const queryParams = new URLSearchParams({
      id: META_PIXEL_ID,
      ev: eventName,
      noscript: '1',
      ...(params || {})
    });
    img.src = `https://www.facebook.com/tr?${queryParams.toString()}`;
  } catch (e) {
    // silently fail
  }
}
export function trackPixelEvent(eventName: string, params?: Record<string, any>) {
  try {
    if (window.fbq) {
      window.fbq('track', eventName, params);
    }
    // Always also fire via image as backup
    firePixelViaImage(eventName, params);
  } catch (e) {
    firePixelViaImage(eventName, params);
  }
}
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <LandingPage data-id="element-0" />;
}